import Component from '../core/Component'
import { submitForm } from '../nette/NetteAutosubmit'
import { triggerEvent } from '../utils/dom'

export default class ProjectFilterForm extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            buttonPdf: null,
            fulltext: null
        }
    }

    prepare() {
        this.element.addEventListener('submit', this.handleSubmit)
        this.element.addEventListener('nette:autosubmit', this.handleNetteAutosubmit)
        this.ref.fulltext.addEventListener('keydown', this.handleInputKeydown)

        const projectFilter = Component.getFromElement('project-filter')

        if (projectFilter) {
            projectFilter.on('searchhide', this.handleCollapse)

            if (this.ref.fulltext.value.trim()) {
                projectFilter.showSearch()
            }
        }
    }

    destroy() {
        const projectFilter = Component.getFromElement('project-filter')
        if (projectFilter) {
            projectFilter.off('searchhide', this.handleCollapse)
        }
    }

    handleCollapse = event => {
        if (this.ref.fulltext?.value) {
            this.ref.fulltext.value = ''
            triggerEvent(this.ref.fulltext, 'change')
        }
    }

    handleSubmit = event => {
        if (!event.submitter.closest('[data-ref="ProjectFilterForm:buttonPdf"]')) {
            event.preventDefault()
        }
    }

    handleInputKeydown = event => {
        if (event.key.toLowerCase() === 'enter') {
            event.preventDefault()
        }
    }

    handleNetteAutosubmit = event => {
        event.preventDefault()
        submitForm(this.element, {
            ajax: true
        })
    }

}
